var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',[_c('data-table',{ref:"table",attrs:{"actions":_vm.actions}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }